import { Outlet } from "react-router-dom";

const PublicMeetingLayout = () => {
  return (
    <div
      className="min-h-screen"
      style={{
        background:
          "linear-gradient(135deg, rgb(30, 41, 59) 0%, rgb(30, 64, 175) 50%, rgb(30, 41, 59) 100%)",
      }}
    >
      <div className="w-full  mx-auto">
        <Outlet />
      </div>
    </div>
  );
};

export default PublicMeetingLayout;
